import {useEffect} from 'react'
import {useSelector} from 'react-redux'
import actions from 'redux-auto'

export const useMyChats = () => {
  const myChats = useSelector(state => state.chat.chats)
  const isLoading = useSelector(state => state.chat.isLoading)

  useEffect(() => {
    if (!myChats && !isLoading) {
      actions.chat.getMyChats()
    }
  }, [myChats, isLoading])

  const chats = myChats
  return {chats, isLoading}
}
